
import { EventManagerIcon } from '@common_components/icons/eventManager.icon';
import { NewsIcon } from '@common_components/icons/news.icon';
import { NoDataAvailableIcon } from '@common_components/icons/noDataAvailable';
import { ClientIcon, SectorIcon, SiteIcon } from '@umanforge/common';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
  type: 'clients' | 'sites' | 'sectors' | 'notes' | 'event_managers';
}

const EmptyState: React.FC<EmptyStateProps> = ( { type } ) => {
  const { t } = useTranslation();

  const getEmptyStateConfig = () => {
    switch ( type ) {
    case 'clients':
      return {
        title: t( 'common:no_clients_available' ),
        description: t( 'common:check_permissions_or_contact_admin' ),
        icon: <ClientIcon className="h-10 w-10 text-red-500" />
      };
    case 'sites':
      return {
        title: t( 'common:no_sites_available' ),
        description: t( 'common:no_sites_associated_with_client' ),
        icon: <SiteIcon className="h-10 w-10 text-red-500" />
      };
    case 'sectors':
      return {
        title: t( 'common:no_sectors_available' ),
        description: t( 'common:no_sectors_associated_with_site' ),
        icon: <SectorIcon className="h-10 w-10 text-red-500" />
      };
    case 'notes':
      return {
        title: t( 'translation:no_notes_available' ),
        description: t( 'translation:no_notes_match_filters' ),
        icon: <NewsIcon size={10} className="text-red-500" />
      };
    case 'event_managers':
      return {
        title: t( 'translation:no_event_manager' ),
        description: t( 'translation:this_sector_doesnt_contain_event_manager' ),
        icon: <EventManagerIcon className="w-10 h-10  text-red-500" />
      };
    default:
      return {
        title: t( 'common:no_data_available' ),
        description: t( 'common:please_try_again_later' ),
        icon: <NoDataAvailableIcon size={10} className="text-red-500" />
      };
    }
  };

  const config = getEmptyStateConfig();

  return (
    <div className="flex flex-col items-center justify-center h-64 text-gray-500">
      <span className="w-16 h-16 mb-4 flex items-center justify-center">{config.icon}</span>
      <h3 className="text-lg font-medium mb-2">{config.title}</h3>
      <p className="text-sm">{config.description}</p>
    </div>
  );
};

export default EmptyState;
